@if ((initialized | async)) {
  <ds-thumbnail data-test="thumbnail"
    [thumbnail]="thumbnail$ | async"
    [defaultImage]="default$ | async">
  </ds-thumbnail>
}
